.experienceLevel {
  display: inline-flex;
  flex-direction: column;
}

.smallPadding {
  padding: var(--spacingMd);
}
